(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jib-cart-conversion"] && !Shopify.designMode) return;
  try {
    class JibCartConversion extends HTMLElement {
    connectedCallback() {
      this.liveRegion = this.querySelector('[data-jib-live]');
      this.handleClick = this.handleClick.bind(this);
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('cart:update', this.handleCartUpdate);
      this.render();
      window.setTimeout(() => this.render(), 500);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('cart:update', this.handleCartUpdate);
    }

    handleCartUpdate() {
      window.setTimeout(() => this.render(), 120);
      window.setTimeout(() => this.render(), 700);
    }

    getItemCount(drawer) {
      const count = drawer.querySelector('[ref="cartItemCount"]')?.textContent;
      return Number.parseInt(count || '0', 10) || 0;
    }

    getCurrentHandles(drawer) {
      const handles = new Set();
      for (const link of drawer.querySelectorAll('.cart-items__title[href*="/products/"]')) {
        const match = link.getAttribute('href')?.match(/\/products\/([^?/#]+)/);
        if (match?.[1]) handles.add(match[1]);
      }
      return handles;
    }

    render() {
      const drawer = document.querySelector('.cart-drawer__dialog');
      if (!drawer) return;

      drawer.querySelectorAll('[data-jib-injected]').forEach((element) => element.remove());

      const count = this.getItemCount(drawer);
      const header = drawer.querySelector('.cart-drawer__header');
      const summary = drawer.querySelector('.cart-drawer__summary');
      const checkoutText = drawer.querySelector('.cart__checkout-button .button-text');

      if (checkoutText) checkoutText.textContent = this.dataset.checkout || '';

      if (count > 0 && header) {
        const unlocked = count >= 2;
        const progress = document.createElement('div');
        progress.className = 'jib-cart-progress';
        progress.dataset.jibInjected = '';
        progress.style.setProperty('--jib-progress', unlocked ? '100%' : '50%');
        progress.innerHTML = `
          <div class="jib-cart-progress__copy">
            <span>${unlocked ? this.dataset.progressDone : this.dataset.progressOne}</span>
            <span class="jib-cart-progress__status" aria-hidden="true">${unlocked ? '✓' : '2'}</span>
          </div>
          <div class="jib-cart-progress__track" aria-hidden="true">
            <div class="jib-cart-progress__fill"></div>
          </div>
        `;
        header.insertAdjacentElement('afterend', progress);
      }

      if (count === 1 && summary) {
        const template = this.querySelector('template[data-jib-products]');
        const currentHandles = this.getCurrentHandles(drawer);
        const products = template
          ? Array.from(template.content.querySelectorAll('.jib-cart-product'))
              .filter((product) => !currentHandles.has(product.dataset.productHandle || ''))
              .slice(0, 3)
          : [];

        if (products.length > 0) {
          const upsell = document.createElement('section');
          upsell.className = 'jib-cart-upsell';
          upsell.dataset.jibInjected = '';
          upsell.setAttribute('aria-label', this.dataset.upsellTitle || '');

          const heading = document.createElement('h3');
          heading.className = 'jib-cart-upsell__heading';
          heading.textContent = this.dataset.upsellTitle || '';

          const text = document.createElement('p');
          text.className = 'jib-cart-upsell__text';
          text.textContent = this.dataset.upsellText || '';

          const grid = document.createElement('div');
          grid.className = 'jib-cart-upsell__products';
          for (const product of products) grid.append(product.cloneNode(true));

          upsell.append(heading, text, grid);
          summary.insertAdjacentElement('beforebegin', upsell);
        }
      }

      if (count > 0 && summary) {
        const ctas = summary.querySelector('.cart__ctas');
        const accelerated = summary.querySelector('.additional-checkout-buttons');

        if (accelerated) {
          const expressLabel = document.createElement('p');
          expressLabel.className = 'jib-cart-express-label';
          expressLabel.dataset.jibInjected = '';
          expressLabel.textContent = this.dataset.express || '';
          accelerated.insertAdjacentElement('beforebegin', expressLabel);
        }

        if (ctas) {
          const trust = document.createElement('div');
          trust.className = 'jib-cart-trust';
          trust.dataset.jibInjected = '';
          const email = this.dataset.supportEmail || '';
          trust.innerHTML = `
            <div class="jib-cart-trust__row">
              <span class="jib-cart-trust__item">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 10V8a5 5 0 0 1 10 0v2M6 10h12v10H6V10Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>${this.dataset.payment || ''}</span>
              </span>
              <span class="jib-cart-trust__item">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6h11v10H3V6Zm11 4h4l3 3v3h-7v-6ZM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>${this.dataset.tracking || ''}</span>
              </span>
              <span class="jib-cart-trust__item">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h11a5 5 0 1 1 0 10H8M4 7l3-3M4 7l3 3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>${this.dataset.returns || ''}</span>
              </span>
            </div>
            ${email ? `<a class="jib-cart-trust__support" href="mailto:${email}">${this.dataset.support || ''}</a>` : ''}
          `;
          ctas.insertAdjacentElement('afterend', trust);
        }
      }
    }

    async handleClick(event) {
      const button = event.target.closest('[data-jib-add]');
      if (!button || !button.closest('.jib-cart-upsell')) return;

      const product = button.closest('.jib-cart-product');
      const select = product?.querySelector('[data-jib-variant]');
      const variantId = select?.value;
      if (!variantId) return;

      button.disabled = true;
      button.textContent = this.dataset.adding || '';

      try {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((component) => component.dataset.sectionId)
          .filter(Boolean);

        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });

        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart error');

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();

        button.textContent = this.dataset.added || '';
        if (this.liveRegion) this.liveRegion.textContent = this.dataset.added || '';

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'jib-cart-upsell',
              data: {
                source: 'jib-cart-upsell',
                itemCount: cart.item_count,
                variantId,
                sections: result.sections,
              },
            },
          })
        );
      } catch (error) {
        button.disabled = false;
        button.textContent = this.dataset.retry || '';
        if (this.liveRegion) this.liveRegion.textContent = this.dataset.retry || '';
      }
    }
  }

  if (!customElements.get('jib-cart-conversion')) {
    customElements.define('jib-cart-conversion', JibCartConversion);
  }
  } catch(e) { console.error(e); }
})();

})();
